import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { Typography } from "@material-ui/core"

import Arrow from "../../static/play_circle_filled-24px.svg"

import * as theme from "../theme"

const ButtonLink = props => {
  return (
    <Container {...props}>
      <Arrow />
      <Typography variant="button" color="inherit">
        {props.children}
      </Typography>
    </Container>
  )
}

export default ButtonLink

const Container = styled(Link)`
  svg {
    opacity: 0.35;
    margin-right: 8px;
    transition: opacity 80ms ease-in-out;
    height: 36px;
    width: 36px;
    fill: ${theme.color.primary};
  }
  display: flex;
  align-items: center;
  text-decoration: none;
  color: ${theme.color.dark};
  transition: color 80ms ease-in-out;
  &:hover {
    color: ${theme.color.primary};
    svg {
      opacity: 1;
    }
  }
`
